import {
  Card,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@t90/ui';
import {
  BookOpen,
  FileText,
  Users,
  ExternalLink,
} from 'lucide-react';

const resources = [
  {
    title: 'Program Handbook',
    description: 'Complete guide to the Turn90 program',
    icon: BookOpen,
    href: '#',
  },
  {
    title: 'Training Materials',
    description: 'Skills training and development resources',
    icon: FileText,
    href: '#',
  },
  {
    title: 'Support Services',
    description: 'Information about available support services',
    icon: Users,
    href: '#',
  },
];

export function ResourcesPage() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Resources</h1>
        <p className="text-muted-foreground">
          Program resources and helpful information
        </p>
      </div>

      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {resources.map((resource) => (
          <Card
            key={resource.title}
            className="cursor-pointer hover:bg-muted/50 transition-colors"
          >
            <CardHeader>
              <div className="flex items-center justify-between">
                <div className="rounded-md bg-primary/10 p-2">
                  <resource.icon className="h-5 w-5 text-primary" />
                </div>
                <ExternalLink className="h-4 w-4 text-muted-foreground" />
              </div>
              <CardTitle className="text-lg">{resource.title}</CardTitle>
              <CardDescription>{resource.description}</CardDescription>
            </CardHeader>
          </Card>
        ))}
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Need Help?</CardTitle>
          <CardDescription>
            If you have questions or need assistance, please contact your team lead
            or program coordinator.
          </CardDescription>
        </CardHeader>
      </Card>
    </div>
  );
}
